// PO Tracking: the budget chart, the PO table and the create / edit / import
// dialogs. "PO" and "Pivot PO" are the terms procurement uses in German too.
//
// Key = the exact English source string used in the code. Value = German.
// Do NOT redefine keys already in common.ts.

export const poTracking: Record<string, string> = {
  'Add new year': 'Neues Jahr hinzufügen',
  'Add year': 'Jahr hinzufügen',
  'e.g. 2027': 'z. B. 2027',
  'Please enter a valid year (2000–2100)': 'Bitte ein gültiges Jahr angeben (2000–2100)',
  'Import POs': 'POs importieren',
  'New PO': 'Neuer PO',

  // Chart card
  Forecast: 'Prognose',
  Line: 'Linie',
  'Line shape': 'Linienform',
  Linear: 'Linear',
  Monotone: 'Weich',
  Step: 'Stufe',
  'Step After': 'Stufe danach',
  'Invoiced amount over time': 'Abgerechneter Betrag im Zeitverlauf',
  'all POs': 'alle POs',
  'Clear filter': 'Filter aufheben',
  'No forecast data available for the selected period.':
    'Für den gewählten Zeitraum liegen keine Prognosedaten vor.',

  // Chart legend and side rail
  Budget: 'Budget',
  'Total PO budget': 'PO-Budget gesamt',
  'Invoiced to date': 'Bisher abgerechnet',
  'Forecast year end': 'Prognose Jahresende',
  'Forecast over budget': 'Prognose über Budget',
  'Remaining forecast': 'Verbleibende Prognose',

  // PO table
  'No POs for this year': 'Keine POs für dieses Jahr',
  'Create a new PO or import the PO list.':
    'Lege einen neuen PO an oder importiere die PO-Liste.',
  'PO number': 'PO-Nummer',
  'Pivot PO': 'Pivot-PO',
  'Total budget': 'Budget gesamt',
  Usage: 'Verbrauch',
  Used: 'Verbraucht',
  Remaining: 'Verbleibend',
  'Show only this PO in the chart': 'Nur diesen PO im Chart zeigen',
  'over budget': 'über Budget',

  // Create / edit dialog
  'Create new PO': 'Neuen PO anlegen',
  'Edit PO': 'PO bearbeiten',
  'PO number is required': 'Die PO-Nummer ist erforderlich',
  'Please enter a valid amount': 'Bitte einen gültigen Betrag angeben',
  'Optional — the umbrella PO this one rolls up to':
    'Optional — der übergeordnete PO, auf den dieser einzahlt',
  'Optional — matched against the supplier whitelist on save':
    'Optional — wird beim Speichern gegen die Lieferanten-Whitelist geprüft',
  'Optional description': 'Beschreibung (optional)',
  'Total value (EUR)': 'Gesamtwert (EUR)',
  'Delete PO?': 'PO löschen?',
  'The purchase order is deleted for good. Linked invoices only lose the assignment — they are not deleted.':
    'Der Purchase Order wird endgültig gelöscht. Verknüpfte Rechnungen verlieren nur die Zuordnung — sie werden nicht gelöscht.',

  // Import dialog
  'Import PO list': 'PO-Liste importieren',
  'POs will be imported for this year': 'Die POs werden für dieses Jahr importiert',
  'Import mode': 'Import-Modus',
  'Update / add (match by PO number, keep invoice assignments)':
    'Aktualisieren / ergänzen (Abgleich über die PO-Nummer, Rechnungszuordnungen bleiben)',
  'Replace the whole year': 'Das ganze Jahr ersetzen',
  'Click to select a PO list file': 'Klicken, um eine PO-Liste auszuwählen',
  'Expected columns:': 'Erwartete Spalten:',
  'This replaces all existing POs for the selected year. Linked invoices are unassigned (not deleted).':
    'Das ersetzt alle vorhandenen POs des gewählten Jahres. Verknüpfte Rechnungen verlieren nur die Zuordnung (sie werden nicht gelöscht).',
  'Existing POs (matched by PO number) are updated in place and keep their linked invoices. New POs are added; other POs of the year are left untouched.':
    'Vorhandene POs (Abgleich über die PO-Nummer) werden aktualisiert und behalten ihre verknüpften Rechnungen. Neue POs kommen hinzu; alle übrigen POs des Jahres bleiben unberührt.',
  'Please select a file': 'Bitte eine Datei auswählen',
  'Importing …': 'Import läuft …',
  'Replaced {year} with {n} POs.': '{year} durch {n} POs ersetzt.',
  '{year}: {updated} updated, {created} added.':
    '{year}: {updated} aktualisiert, {created} hinzugefügt.',
  '{n} supplier(s) not in the whitelist:': '{n} Lieferant(en) nicht in der Whitelist:',

  // Assignment from the PO list (approver / legal counsel / entity)
  'Responsible person': 'Verantwortliche Person',
  'Responsible person (approver)': 'Verantwortliche Person (Approver)',
  'Approves invoices on this PO — shown as initials in the Approver column':
    'Gibt Rechnungen auf diese PO frei — erscheint als Kürzel in der Spalte Approver',
  'Same as responsible person': 'Wie verantwortliche Person',
  'From the PO number': 'Aus der PO-Nummer',
  'Fill assignments': 'Zuordnung nachziehen',
  'Fill empty entity, approver and legal counsel fields of existing invoices from their PO':
    'Leere Felder Gesellschaft, Approver und Legal Counsel bestehender Rechnungen aus ihrer PO füllen',
  '{n} invoice(s) completed with entity, approver and legal counsel.':
    '{n} Rechnung(en) um Gesellschaft, Approver und Legal Counsel ergänzt.',
  'Request failed': 'Anfrage fehlgeschlagen',
}
